"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDevice = exports.getUserAgent = exports.getViewInfo = exports.getLocale = exports.getVisitorId = void 0;

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _isMobile = _interopRequireDefault(require("is-mobile"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ADOBE_COOKIE = 'AMCV_5C36123F5245AF470A490D45@AdobeOrg';
var ADOBE_ID = '5C36123F5245AF470A490D45@AdobeOrg';
var INSTANCE_ID = '1americanexpress';
var CLOUD_ID = '91449312317105777891808274921855287655';

var getVisitorId = function getVisitorId() {
  if (global.window && window.Visitor) {
    var instance = window.Visitor.getInstance(ADOBE_ID, INSTANCE_ID);
    return instance.getMarketingCloudVisitorID && instance.getMarketingCloudVisitorID(CLOUD_ID);
  }

  var adobeCookie = _jsCookie.default.get(ADOBE_COOKIE);

  if (adobeCookie) {
    var adobeArray = adobeCookie.split('|');
    var visitorIdIndex = adobeArray.indexOf('MCMID') + 1;
    return adobeArray[visitorIdIndex];
  }

  return undefined;
};

exports.getVisitorId = getVisitorId;

var getLocale = function getLocale() {
  return _jsCookie.default.get('axplocale') || navigator.language || 'en-US';
};

exports.getLocale = getLocale;

var getViewInfo = function getViewInfo(pathname) {
  var locale = getLocale();
  var path = pathname || window.location.pathname;
  return {
    viewId: path,
    // Doing this over location.href because the page update may happen
    // during route transition, meaning the href would be the current page,
    // not the page we are transitioning to.
    location: "".concat(window.location.origin).concat(path).concat(window.location.search || ''),
    title: document.title || 'No Title',
    referrer: document.referrer || undefined,
    locale: locale,
    country: locale.split('-')[1],
    language: locale.split('-')[0],
    origin: window.location.origin
  };
};

exports.getViewInfo = getViewInfo;

var getUserAgent = function getUserAgent() {
  return navigator.userAgent || navigator.vendor || window.opera;
}; // eslint-disable-next-line no-confusing-arrow


exports.getUserAgent = getUserAgent;

var getChannel = function getChannel() {
  return (0, _isMobile.default)(getUserAgent()) ? 'mobile' : 'desktop';
};

var getDevice = function getDevice() {
  return {
    userAgent: global.window && getUserAgent(),
    width: {
      px: global.screen && global.screen.width
    },
    height: {
      px: global.screen && global.screen.height
    },
    channel: global.window && getChannel()
  };
};

exports.getDevice = getDevice;